import type {
  IOId,
  IOModalData,
  IOModalsType,
  NewIOType,
} from '../types/insertionOrder.js';
import { useSetInsertionOrderModalData } from './useInsertionOrderModal.js';

type DataForValidation = {
  ioData: IOId[];
  buyingPlanId: number;
  buyingPlanItemId: number;
};

const prepareDataForCreation = (data: DataForValidation) => {
  const { ioData = [], ...rest } = data;

  return {
    ioId: ioData[0].ioId,
    ...rest,
  };
};

export const useInsertionOrderValidation = () => {
  const setInsertionModalData = useSetInsertionOrderModalData();

  const openInsertionOrderModal = (type: IOModalsType, data: IOModalData) => {
    setInsertionModalData({
      isOpen: true,
      type,
      data,
    });
  };

  const handleInsertionOrderOnPlatformLevel = async (
    data: DataForValidation,
    createNewInsertionOrder: (data: NewIOType) => Promise<void>,
  ) => {
    const isSingleInsertionOrderItem = data.ioData.length === 1;

    if (isSingleInsertionOrderItem) {
      const insertionOrderData = prepareDataForCreation(data);
      await createNewInsertionOrder(insertionOrderData);
      return;
    }

    const haveInsertionOrderWithoutId = data.ioData.some((io) => !io.ioId);

    if (haveInsertionOrderWithoutId) {
      openInsertionOrderModal('list_with_new', data);
      return;
    }

    openInsertionOrderModal('list', data);
  };

  const handleInsertionOrderOnMediaRowLevel = async (
    data: DataForValidation,
    createNewInsertionOrder: (data: NewIOType) => Promise<void>,
  ) => {
    const typeOfModal = data.ioData[0]?.ioId ? 'existing' : 'creation';

    const shouldTheModalBeOpened = !localStorage.getItem(typeOfModal);

    if (!shouldTheModalBeOpened) {
      await createNewInsertionOrder(prepareDataForCreation(data));
      return;
    }

    openInsertionOrderModal(typeOfModal, data);
  };

  const handleInsertionOrderValidation = async (
    data: DataForValidation,
    isPlatformLevel: boolean,
    createNewInsertionOrder: (data: NewIOType) => Promise<void>,
  ) => {
    if (isPlatformLevel) {
      await handleInsertionOrderOnPlatformLevel(data, createNewInsertionOrder);
      return;
    }

    await handleInsertionOrderOnMediaRowLevel(data, createNewInsertionOrder);
  };

  return { handleInsertionOrderValidation };
};
